import React from 'react';
import { createSessionConsumer } from './actionCableConsumer';
import { addCommentsToThread, Comment } from '../../store/Comment';
import { useSnackbar } from '../../Context/SnackbarContext';
import { getUser } from '../../store/User';

export const useCommentChannel = (entityId: string, entityType: string) => {
  const { setSnack } = useSnackbar();

  React.useEffect(() => {
    const commentConsumer = createSessionConsumer('comment');
    if (!commentConsumer) return;

    const subscription = commentConsumer.subscriptions.create(
      {
        channel: 'CommentChannel',
        entity_id: entityId,
        entity_type: entityType
      },
      {
        connected: () => {},
        disconnected: () => {},
        received: (data: { type: string; comments?: Comment[] }) => {
          const othersComments = (data.comments ?? []).filter(
            (comment) => comment.portal_user_id?.toString() !== getUser().id
          );
          if (othersComments.length && addCommentsToThread(othersComments).length) {
            setSnack({ message: 'New comment received', type: 'info', open: true });
          }
        }
      }
    );

    return () => {
      // disconnect() leaves a still-connecting socket open, and on open it would subscribe this record into the next one's thread.
      subscription.unsubscribe();
      commentConsumer.disconnect();
    };
  }, [entityId, entityType]);

  return null;
};
